import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  listRoles,
  createRole,
  updateRole,
  deleteRole,
} from "@/services/auth";

@Module({
  namespaced: true,
})
export default class Role extends VuexModule {
  // state
  roleList = [];

  // actions
  @Action
  public async fetchRoles() {
    try {
      const data = await listRoles();
      this.context.commit("setRoleList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createRole(payload) {
    try {
      const data = await createRole(payload);
      this.context.dispatch("fetchRoles");
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateRole(payload) {
    try {
      const data = await updateRole(payload._id, payload.data);
      this.context.dispatch("fetchRoles");
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteRole(payload) {
    try {
      const data = await deleteRole(payload);
      this.context.dispatch("fetchRoles");
      return data;
    } catch (error) {
      throw error;
    }
  }

  // mutations
  @Mutation
  public setRoleList(data: any) {
    this.roleList = data.reverse();
  }

  // getters
  get GetRoleList() {
    return this.roleList;
  }
}
